import { Card } from "react-bootstrap";
import { NavLink } from "react-router-dom";
// import Card from "../../../ui/card/Card";
import Card1 from "../../../ui/card/Card1";
import analytics from "../../../dashboardicon/Analytics.svg";
import ctm from "../../../dashboardicon/ControlTableManagement.svg";
import erm from "../../../dashboardicon/E-RollManagement.svg";
import fpr from "../../../dashboardicon/FormProcessing.svg";
import pop1 from "../../../dashboardicon/Population1.svg";
import um from "../../../dashboardicon/Usermanagement.svg";
import Dashboard from "../Dashboard/Dashboard";
import LeftMenu from "../../AnalyticsModule/Left";
import {useLazyGetPhaseNodetailsQuery } from "../../../services/announceElection";
import { useEffect } from "react";
import Button from "../../../library/components/Button";
import { USERTYPE } from "../../../constants/constants";

function EciDashboard() {
  const [phaseNo,datap] = useLazyGetPhaseNodetailsQuery()

  
 
useEffect(()=>{
  phaseNo().then((res)=>{
    var data = []
res?.data?.payload?.map((item)=>{
  data.push(item?.phaseNo)
})
let string = JSON.stringify(data)
localStorage.setItem("phaseList",string)
  })
},[])

  return (
    <>
     <LeftMenu>
     <Dashboard/>
     </LeftMenu>
    </>
  );
}

export default EciDashboard;
